"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceLastOccurrence = exports.PascalCaseToTitleCase = void 0;
/**
 * Inserts a space before every uppercase character and trims the leading and trailing space.
 * E.g. "RoomSpaceInventory" becomes "Room Space Inventory".
 */
function PascalCaseToTitleCase(stringToFormat) {
    if (!stringToFormat) {
        return stringToFormat;
    }
    return stringToFormat.replace(/([A-Z])/g, " $1").trim();
}
exports.PascalCaseToTitleCase = PascalCaseToTitleCase;
/**
 * Replaces the last occurrence of a string.
 * @param inString The string to test
 * @param find What to find
 * @param replace Replace the found item with.
 */
function ReplaceLastOccurrence(inString, find, replace) {
    var index = inString.lastIndexOf(find);
    if (index >= 0) {
        return inString.substring(0, index) + inString.substring(index).replace(find, replace);
    }
    return inString.toString();
}
exports.ReplaceLastOccurrence = ReplaceLastOccurrence;
